// extracted by mini-css-extract-plugin
export var bgWrapper = "style-module--bgWrapper--DCWrn";
export var divider = "style-module--divider--vm0fG";
export var dotsWrapper2 = "style-module--dotsWrapper2--+W9t9";
export var header = "style-module--header--2m04d";
export var highlight = "style-module--highlight--Od3pp";
export var img = "style-module--img--0rqUG";
export var imgWrapper = "style-module--imgWrapper--rD182";
export var place = "style-module--place--e0Pc3";
export var project = "style-module--project--7BO4D";
export var projectTitle = "style-module--projectTitle--fV0x4";
export var root = "style-module--root--KIckC";
export var text = "style-module--text--eFrc7";
export var title = "style-module--title--FzxnZ";
export var winners = "style-module--winners--DTk4O";
export var winnersImg = "style-module--winnersImg--tG4WN";
export var winnersTitle = "style-module--winnersTitle--anjz0";